<template>
	<button class="button is-info is-fullwidth" :class="{'is-loading': loading}" v-facebook-signin-button @click.prevent="fbLoginTry">
		<span class="icon"><font-awesome-icon :icon="['fab','facebook-f']" /></span>
		<span v-if="text">{{text}}</span>
	</button>
</template>

<script>
	export default {
		props:{
			text: {
				type: String,
				default: ''
			}
		},
		name: 'FacebookLoginButton',

		data() {
			return {
				loading: false
			};
		},
		methods: {
			fbLoginTry(){
				this.loading = true
				var _self = this
				window.FB.getLoginStatus(function(resp){ 
					if (resp.status !== "connected") {
						//IF not connected try to login
						return window.FB.login(function(resp) {
							if (resp.status == "unknown") {
		                		_self.onFail(resp)
							}else{
								_self.onSuccess(resp)
							}
						},{scope: 'email'});
					}else{
						_self.onSuccess(resp)
					}
				});
			},
			onSuccess(resp){
				this.$emit('success',resp)
				this.loading = false
			},
			onFail(resp){
				this.$emit('failed',resp)
				this.loading = false
			}
		},
		directives: {
			'facebook-signin-button': {
				bind(){
					let fbSignInAPI = document.createElement('script')
					fbSignInAPI.setAttribute('src', 'https://connect.facebook.net/en_US/sdk.js')
					document.head.appendChild(fbSignInAPI)

					fbSignInAPI.onload = initFacebookSDK

					function initFacebookSDK(){
						window.fbAsyncInit = function() {
							window.FB.init({
								appId            : '132676353471772',
								autoLogAppEvents : true,
								xfbml            : true,
								version          : 'v6.0'
							});
						};
					}
				}
			}
		}
	};
</script>

<style lang="css" scoped>
</style>
